$(document).ready(function(){
    $('.car-slider').slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        loop: false,
        lazyLoad: 'ondemand',
        prevArrow: '<div class="slick-arrow slick-arrow--prev"></div>',
        nextArrow: '<div class="slick-arrow slick-arrow--next"></div>',
    });

    $(".img-wrap").on("mouseenter", ".img-list__item", function () {
        var img = $(this).attr("data-src");
        $(this).siblings(".img-list__item").removeClass("active");
        $(this).addClass("active");
        $(this).parents(".img-wrap").find(".img-wrap__image").attr("src", img);
    })
    $(".img-list").on("click", ".img-wrap__image", function () {
        var img = $(this).attr("src");
        $(this).siblings(".img-wrap__image").removeClass("active");
        $(this).closest("div").prev().find(".img-wrap__image").attr("src", img);
})
});